/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Mk_Tut_Issue_GInputs */

const en_mk_tut_issue_g = /** @type {(inputs: Mk_Tut_Issue_GInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`The issue is the unit of work here. Creating one has to be fast, or people drift back to a WhatsApp group.`)
};

const id_mk_tut_issue_g = /** @type {(inputs: Mk_Tut_Issue_GInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Issue adalah satuan kerja di sini. Membuatnya harus cepat, kalau tidak orang akan kembali ke grup WhatsApp.`)
};

/**
* | output |
* | --- |
* | "The issue is the unit of work here. Creating one has to be fast, or people drift back to a WhatsApp group." |
*
* @param {Mk_Tut_Issue_GInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const mk_tut_issue_g = /** @type {((inputs?: Mk_Tut_Issue_GInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Mk_Tut_Issue_GInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_mk_tut_issue_g(inputs)
	return en_mk_tut_issue_g(inputs)
});